// @flow

import { parseJSDate } from "../../../../../../utils";

const currentDate = () => parseJSDate(new Date());

export { currentDate };
